const BASE_URL = process.env.NODE_ENV === "production" ? "." : "http://localhost:8080"
module.exports = {
  BASE_URL,
  plugins: {
    "posthtml-include": {},
    "posthtml-archie": {},
     "posthtml-punainen-lista-metsa": {}, 
     "posthtml-custom-elements": { defaultTag: "div", skipTags: ['svg-kuva', "each", "lottie-player"] },
    "posthtml-md": {
      "root": "."
    }, 
    'posthtml-expressions': {
      removeScriptLocals: true,
      locals: {
        APP_NAME: process.env.APP_NAME,
        BASE_URL
      },
    },
  },
};
